import { IonIcon, IonButton, IonButtons, IonSpinner } from '@ionic/react';
import { locate, videocam, videocamOff } from 'ionicons/icons';
import { StatesUserInput } from './index';
import { useTranslation } from 'react-i18next';
import { Device } from 'util/device';
import DynamicButton from 'components/buttons/DynamicButton';
import { Trans } from 'react-i18next';

interface RecordButtonsProps {
  canRecord: boolean;
  state: StatesUserInput;
  toggleRecording: () => void;
  tare: () => void;
  videoActive: boolean;
  toggleVideo: () => void;
}

const VideoButton = (props: {
  videoActive: boolean;
  toggleVideo: () => void;
  state: StatesUserInput;
}) => {
  const { toggleVideo, videoActive, state } = props;
  const className = videoActive
    ? 'centering activeText'
    : ' centering inactiveText';

  if (state !== StatesUserInput.Idle)
    return <div className={className} id="videoToggle" />;

  return (
    <div className={className} id="videoToggle">
      <IonIcon
        onClick={toggleVideo}
        className="tareButton"
        icon={videoActive ? videocam : videocamOff}
        mode="ios"
      />
    </div>
  );
};

const getButtonClass = (state: StatesUserInput) => {
  switch (state) {
    case StatesUserInput.Idle:
      return 'Idle';
    case StatesUserInput.Record:
      return 'animate__animated animate__zoomIn animate__faster Recording';
    case StatesUserInput.Tare:
      return 'Taring';
    default:
      return 'Idle';
  }
};

const TareButton = (state: StatesUserInput, onClick: () => void) => {
  if (state === StatesUserInput.Idle) {
    return (
      <IonIcon
        onClick={onClick}
        className="tareButton"
        icon={locate}
        mode="ios"
      />
    );
  }
  if (state === StatesUserInput.Tare)
    return <IonSpinner name="crescent" style={{ width: 48, height: 48 }} />;
  return null;
};

const InputsUser = (props: RecordButtonsProps) => {
  const { t } = useTranslation();
  const { canRecord, state, toggleRecording, tare, toggleVideo, videoActive } =
    props;

  if (!canRecord && !Device.isVirtual) {
    return (
      <div className="buttonArea">
        <div className="buttonAreaContent">
          <div style={{ flex: 1 }}></div>
          <IonButtons>
            <DynamicButton
              iconName="ShopIcon"
              text={<Trans i18nKey="GET_YOUR_FREAK_HERE" />}
              buttonType="icon-text"
              fill="solid"
              size="default"
              color="primary"
              iconColor="secondary"
              onClick={() =>
                window.open(t('SHOP_URL')!, 'www.spinnax.com/shop')
              }
            />
          </IonButtons>
          <div style={{ flex: 1 }}></div>
        </div>
      </div>
    );
  }

  const buttonClass = getButtonClass(state);
  return (
    <div className="buttonArea animate__animated animate__fadeInUp animate__faster">
      <div className="buttonAreaContent">
        <div className="centering" style={{ flex: '0 0 auto' }}>
          <VideoButton
            videoActive={videoActive}
            toggleVideo={toggleVideo}
            state={state}
          />
        </div>
        <div className="centering" style={{ flex: '1 1 auto' }}>
          {state !== StatesUserInput.Tare && (
            <div
              id="recordButton"
              className={buttonClass}
              onClick={toggleRecording}
            />
          )}
        </div>
        <div className="centering" style={{ flex: '0 0 auto' }}>
          {TareButton(state, tare)}
        </div>
      </div>
    </div>
  );
};

export default InputsUser;
